module.exports = __webpack_public_path__ + "static/FNZ-logo-d9b372ba157e7545ceacff05e14da5e7.png";